import { render } from "./formula_modal.vue?vue&type=template&id=b9c529e8"
import script from "./formula_modal.vue?vue&type=script&lang=js"
export * from "./formula_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__